import { useState, useEffect, useCallback, createElement } from 'react';
import classNames from 'classnames';
import './index.less';
const DataVTabs = (props) => {
    const { className, tabs, defaultActiveKey, autoplay = false, autoplaySpeed = 3000, afterChange, infinite = true, pauseOnHover = true, } = props;
    const getStableKey = useCallback((tab, index) => {
        return tab.key ?? `tab_${index}`;
    }, []);
    const [activeIndex, setActiveIndex] = useState(() => {
        if (defaultActiveKey) {
            const idx = tabs.findIndex((tab) => getStableKey(tab, tabs.indexOf(tab)) === defaultActiveKey);
            return idx >= 0 ? idx : 0;
        }
        return 0;
    });
    const [isHovering, setIsHovering] = useState(false);
    const handleTabChange = useCallback((newIndex) => {
        if (newIndex === activeIndex)
            return;
        setActiveIndex(newIndex);
        afterChange?.(getStableKey(tabs[newIndex], newIndex), tabs[newIndex]);
    }, [activeIndex, afterChange, tabs, getStableKey]);
    useEffect(() => {
        if (!autoplay || tabs.length <= 1 || (pauseOnHover && isHovering))
            return;
        const timer = setInterval(() => {
            const nextIndex = activeIndex + 1 >= tabs.length ? (infinite ? 0 : activeIndex) : activeIndex + 1;
            handleTabChange(nextIndex);
        }, autoplaySpeed);
        return () => clearInterval(timer);
    }, [
        activeIndex,
        autoplay,
        autoplaySpeed,
        infinite,
        tabs.length,
        pauseOnHover,
        isHovering,
        handleTabChange,
    ]);
    useEffect(() => {
        if (activeIndex >= tabs.length) {
            setActiveIndex(Math.max(0, tabs.length - 1));
        }
    }, [tabs.length]);
    const handleHover = useCallback((hovering) => {
        if (pauseOnHover) {
            setIsHovering(hovering);
        }
    }, [pauseOnHover]);
    return (createElement("div", { className: classNames('data-v-tabs', className), onMouseEnter: () => handleHover(true), onMouseLeave: () => handleHover(false) },
        createElement("div", { className: "tabs-nav" }, tabs?.map((tab, index) => (createElement("div", { key: getStableKey(tab, index), className: classNames('tab-nav-item', {
                active: index === activeIndex,
            }), onClick: () => handleTabChange(index) }, tab.title)))),
        createElement("div", { className: "tabs-content" },
            createElement("div", { className: "tab-content-item" }, tabs?.[activeIndex]?.content))));
};
export default DataVTabs;
